export default "__VITE_ASSET__DqbLXVG3__"